import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    FormWrapperItem,
} from "../../../common/component/Index";
import { PATHS, FEATURE_FLAGS, DETAIL_ACTIONS, ALL_LANGUAGE_ENUM } from "../../../../../constants/Define";
import { message, Icon } from 'antd';
import { isEqual, get, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import GroupCategory from '../../../../../models/GroupCategory';
import Wrapper from './../../../common/component/Wrapper';
import Input from './../../../common/component/Input';
import LanguageSelect from './../../../modules/LanguageSelect';
import AntSelect, { AntOption } from './../../../common/component/AntSelect';
import TranslateButton from './../../../common/component/TranslateButton';
import TranslateDetail from '../../../modules/TranslateDetail';
import { cloneDeep } from 'lodash'

import './GroupCategoryDetail.less';
import TreeSelect from '../../../common/component/TreeSelect';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
};

export default class GroupCategoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            groupCategory: this.props.groupCategoryState.detail.groupCategory,
        };
        this.basicInfoRef = React.createRef()
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setGroupCategoryDetail(new GroupCategory())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.groupCategoryState.detail.groupCategory && !isEqual(nextProps.groupCategoryState.detail.groupCategory, this.props.groupCategoryState.detail.groupCategory)) {
            this.setGroupCategoryDetail(nextProps.groupCategoryState.detail.groupCategory)
        }
    }

    render() {
        const { t, groupCategoryState } = this.props;
        const { isFetching, allGroupCategories, isFetchingDetail, detail } = groupCategoryState;
        const { action, validation, groupCategory } = this.state;
        const allCategories = action === DETAIL_ACTIONS.UPDATE && groupCategory.id ? allGroupCategories.filter(item => item.id !== groupCategory.id) : allGroupCategories;
        return (
            <LoadingComponent spinning={isFetchingDetail}>
                <PageListComponent className="group-category-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vouchers'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.groupCategory.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.groupCategory.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={groupCategory.translations}
                                current={groupCategory.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        submitButtonRight={true}
                    >
                        <FormWrapperItem>
                            <Wrapper className="col-md-5">
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={groupCategory.name}
                                    validation={validation.name}
                                    labelTitle={t(`item.groupCategory.name`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`name`} onChange={(e) => this.onChangeDetail('name', e.target.value)}
                                        value={Func.checkUndefine(groupCategory.name)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-2">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.groupCategory.order`)}
                                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                >
                                    <Input placeholder="" type={`number`}
                                        className={`form-control`}
                                        name={`order`} onChange={(e) => this.onChangeDetail('order', e.target.value)}
                                        value={Func.checkUndefine(groupCategory.order)} />
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-5 select-parent">
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.groupCategory.parentName`)}
                                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                >
                                    <LoadingComponent spinning={isFetching}>
                                        <AntSelect className="select-parent"
                                            allowClear
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.groupCategory.parentName")).toLowerCase())}
                                            value={groupCategory.parentId}
                                            onChange={value => this.onChangeDetail('parentId', value)}
                                            style={{ width: '100%' }}
                                            filterOption={this.selectFilterSearch}
                                        >
                                            {allCategories.map(d => (
                                                <AntOption key={d.id} value={d.id}>{d.name}</AntOption>
                                            ))}
                                        </AntSelect>
                                    </LoadingComponent>
                                    {/* <LoadingComponent spinning={isFetching}>
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            value={groupCategory.parentId}
                                            treeDefaultExpandAll
                                            treeData={allGroupCategories}
                                            onChange={id => this.onChangeDetail('parentId', id)}
                                        />
                                    </LoadingComponent> */}
                                </FormWrapperInputComponent>
                            </Wrapper>
                        </FormWrapperItem>

                    </FormActionComponent>
                </PageListComponent>
                
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, groupCategoryState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            const groupCategory = find(groupCategoryState.groupCategories, h => h.id === id);
            if (groupCategory) this.setGroupCategoryDetail(groupCategory);
            this.props.getGroupCategoryDetail(id);
        }
        this.props.getAllGroupCategories({ withoutChildren: true, excludedId: match.params.id });
    }

    onChangeDetail = (fieldName, value) => {
        const groupCategory = this.state.groupCategory;
        groupCategory[fieldName] = value;
        this.setState({ groupCategory });
    };

    setGroupCategoryDetail = (groupCategoryDetail) => {
        const groupCategory = cloneDeep(groupCategoryDetail);
        this.setState({ groupCategory, action: groupCategory.id ? DETAIL_ACTIONS.UPDATE : this.state.action });

    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.updateGroupCategoryDetail()
            }
        }
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.GROUP_CATEGORY.LIST.path);
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.groupCategory.name`)),
            },
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.groupCategory, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateGroupCategoryDetail() {
        const { groupCategory, action } = this.state;
        const actionFunction = action === DETAIL_ACTIONS.CREATE ? this.props.createGroupCategory : this.props.updateGroupCategory;
        actionFunction(groupCategory);
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onShowTranslate = (language) => {
        const { groupCategory } = this.state;
        groupCategory.setTranslate(language.code);
        groupCategory.setData();
        this.setState({ groupCategory, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const groupCategory = cloneDeep(this.state.groupCategory);
        const action = DETAIL_ACTIONS[groupCategory.id ? 'UPDATE' : 'CREATE'];
        groupCategory.setTranslate(undefined, true);
        groupCategory.setData();
        this.setState({ groupCategory, action });
    }

    onSaveTranslate = () => {
        const { groupCategory } = this.state;
        const translateFunction = groupCategory.translate.id ? this.props.updateGroupCategoryTranslate : this.props.createGroupCategoryTranslate;
        translateFunction(groupCategory, groupCategory.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { groupCategory } = this.state;
        groupCategory.setTranslate(language.code);
        this.props.deleteGroupCategoryTranslate(groupCategory, { id: groupCategory.id });
    }

}
